































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { routeName } from '@/constants/route.constants';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import { TableField } from '@/models/table-field.model';
import { RegistrationFilter } from '@/models/registration-filter.model';
import { mapState } from 'vuex';
import { Options } from '@/models/options.model';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { VeterinarianOffice } from '@/models/DTO/veterinarian-office/veterinarian-office.model';
import VeterinarianModule, {
  VETERINARIAN_MODULE_NAME
} from '@/store/modules/veterinarian.module';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from '@/store/modules/registered-tag.module';
import AuthenticationModule from '@/store/modules/authentication.module';
import { Role } from '@/constants/role.constants';
import TableContextMixin from '@/mixins/table-context.mixin';
import { TableContext } from '@/models/table-context.model';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import { RegistrationReport } from '@/models/registration-report.model';
import { snakeCase } from 'lodash';
import LoadingComponent from '@/components/shared/loading.component.vue';
import { AnonymousRegistration } from '@/constants/anonymous-registration.constants';
import ManageTagFormComponent from '@/components/registration/manage-tag-form.component.vue';

const veterinarianModule: VeterinarianModule = getModule(
  VeterinarianModule,
  store
);

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

@Component({
  components: {
    LoadingComponent,
    ManageTagFormComponent
  },
  computed: {
    routeName(): typeof routeName {
      return routeName;
    },
    showFiltered(): boolean {
      return (
        this.$data.records > 0 &&
        this.$data.filter &&
        this.$data.filter.startDate &&
        this.$data.filter.endDate
      );
    },
    ...mapState(VETERINARIAN_MODULE_NAME, [
      'veterinarianOffices',
      'selectedVeterinarianOfficeId',
      'showTableLoading',
      'errorResponse'
    ]),
    ...mapState(REGISTERED_TAG_MODULE_NAME, {
      registeredTags: 'registeredTags',
      showLoading: 'showTableLoading',
      errorTagResponse: 'errorResponse'
    })
  }
})
export default class RegistrationListComponent extends mixins(
  TableContextMixin
) {
  public veterinarianOffices: Array<VeterinarianOffice>;
  public selectedVeterinarianOfficeId: string;
  public registeredTags: Array<RegisteredTag>;
  public filteredRegisteredTags: Array<RegisteredTag> = [];
  public showLoading: boolean;
  public showTableLoading: boolean;
  public errorResponse: BaseAPIErrorModel | null;
  public errorTagResponse: BaseAPIErrorModel | null;
  public currentPage = 1;
  public recordsPerPage = 10;
  public sortBy = 'dateCreatedUtc';
  public sortDesc = true;
  public records = 0;
  public filter: RegistrationFilter | null = null;
  public accountOptions: Array<Options> = [];
  public selectedAccountId = '';
  public selectedRegisteredTag: RegisteredTag | null = null;

  public tableFilter: RegistrationFilter = {
    startDate: '',
    endDate: '',
    search: ''
  };

  public fields: Array<TableField> = [];

  public get role(): typeof Role {
    return Role;
  }

  public get roles(): Array<string> {
    return authenticationModule.jwtRoles;
  }

  public get veterinarianOfficeId(): string {
    return authenticationModule.jwtVeterinarianOfficeId;
  }

  @Watch('registeredTags', { deep: true })
  private onRegisteredTagsChanged() {
    return this.getNumberOfRecords();
  }

  @Watch('selectedVeterinarianOfficeId')
  private async onSelectedVeterinarianOfficeIdChanged(
    value: string,
    oldValue: string
  ) {
    if (value && value !== oldValue) {
      this.selectedAccountId = value;
      this.fields = this.setFields();

      await this.getRegesteredTagListByOfficeId(value);
    }
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  @Watch('errorTagResponse', { deep: true })
  private onErrorTagResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public async created() {
    this.fields = this.setFields();
    this.filter = null;
    this.tableFilter.startDate = '';
    this.tableFilter.endDate = '';
    this.tableFilter.search = '';
    this.records = this.registeredTags.length;

    if (this.roles.includes(Role.Admin)) {
      this.getAccountsList();
    } else {
      await veterinarianModule.setSelectedVeterinarianOfficeIdAction(
        this.veterinarianOfficeId
      );
    }
  }

  public mounted() {
    if (this.currentTableContext) {
      this.currentPage = this.currentTableContext.currentPage;
      this.recordsPerPage = this.currentTableContext.perPage;
      this.sortBy = this.currentTableContext.sortBy;
      this.sortDesc = this.currentTableContext.sortDesc;
      this.tableFilter.startDate = this.currentTableContext.startDate || '';
      this.tableFilter.endDate = this.currentTableContext.endDate || '';
      this.tableFilter.search = this.currentTableContext.filter || '';

      if (
        this.tableFilter.search !== '' ||
        this.tableFilter.startDate !== '' ||
        this.tableFilter.endDate !== ''
      ) {
        this.filter = this.tableFilter;
      } else {
        this.filter = null;
      }
    }
  }

  public setFields(): Array<TableField> {
    let fields: Array<TableField> = [
      {
        key: 'code',
        sortable: true,
        stickyColumn: true
      },
      // {
      //   key: 'customerfirstname',
      //   sortable: true,
      //   label: 'First Name',
      //   headerTitle: 'Customer first name'
      // },
      // {
      //   key: 'customerlastname',
      //   sortable: true,
      //   label: 'Last Name',
      //   headerTitle: 'Customer last name'
      // },
      {
        key: 'customeremail',
        sortable: true,
        label: 'Customer Email'
      },
      {
        key: 'createdBy',
        sortable: true,
        label: 'Created By',
        headerTitle: 'Registered by'
      },
      {
        key: 'dateCreatedUtc',
        sortable: true,
        label: 'Created',
        headerTitle: 'Initial registration date'
      },
      {
        key: 'dateModifiedUtc',
        sortable: true,
        label: 'Modified',
        headerTitle: 'Registration modified date'
      },
      {
        key: 'customerId',
        sortable: true,
        label: 'Status'
      },
      {
        key: 'id',
        sortable: false,
        label: '',
        tdClass: 'text-right',
        headerTitle: 'Edit customer information on tag.'
      }
    ];

    if (this.selectedVeterinarianOfficeId === AnonymousRegistration.id) {
      fields = fields.filter((item) => item.key !== 'id');
    }

    return fields;
  }

  public async getRegesteredTagListByOfficeId(officeId: string) {
    await registeredTagModule.getAllTagsByVeterinarianOfficeIdAction(officeId);
  }

  public async getAccountsList() {
    if (this.veterinarianOffices.length === 0) {
      await veterinarianModule.getVeterinarianOfficesAction();
    }

    // Write out the accounts dropdown for admins
    this.accountOptions = this.veterinarianOffices.map((office) => {
      return {
        text: `${office.name} (${office.city || 'UNKNOWN'})`,
        value: office.id || ''
      };
    });

    if (!this.selectedVeterinarianOfficeId) {
      if (this.veterinarianOffices.length > 0) {
        this.selectedAccountId = this.accountOptions[0].value.toString();
        this.onAccountSelectionChange();
      }
    } else {
      this.selectedAccountId = this.selectedVeterinarianOfficeId;
    }
  }

  public getNumberOfRecords() {
    this.records = this.registeredTags.length;
  }

  public onFilterClick() {
    if (
      this.tableFilter.search ||
      (this.tableFilter.startDate && this.tableFilter.endDate)
    ) {
      this.filter = { ...this.tableFilter };
      this.currentPage = 1;
    } else {
      this.filter = null;
    }
  }

  public filterTableResults(
    row: RegisteredTag,
    filter: RegistrationFilter
  ): boolean {
    if (!filter) {
      return false;
    }

    const regex = new RegExp(filter.search.replace('+', '\\+'), 'i');
    const rowBreakdown = JSON.parse(JSON.stringify(row));

    if ((filter.search && !filter.startDate) || !filter.endDate) {
      return Object.values(rowBreakdown).some((e) =>
        regex.test(JSON.stringify(e))
      );
    }

    const rowUTCDate: moment.Moment = Vue.filter('localDateOnly')(
      row.dateCreatedUtc
    );
    const rowDate = this.$moment(rowUTCDate).startOf('day');

    return (
      rowDate.isSameOrAfter(this.$moment(filter.startDate).startOf('day')) &&
      rowDate.isSameOrBefore(this.$moment(filter.endDate).startOf('day')) &&
      (filter.search
        ? Object.values(rowBreakdown).some((e) => regex.test(JSON.stringify(e)))
        : true)
    );
  }

  public onFiltered(filteredItems: Array<RegisteredTag>) {
    this.filteredRegisteredTags = [...filteredItems];
    this.records = filteredItems.length;
  }

  public onResetClick() {
    this.filter = null;
    this.tableFilter.startDate = '';
    this.tableFilter.endDate = '';
    this.tableFilter.search = '';
  }

  public async onAccountSelectionChange() {
    await veterinarianModule.setSelectedVeterinarianOfficeIdAction(
      this.selectedAccountId
    );
  }

  public onContextChanged(context: TableContext) {
    this.setTableContext({
      ...context,
      filter: this.tableFilter.search,
      startDate: this.tableFilter.startDate,
      endDate: this.tableFilter.endDate,
      pageName: this.page || ''
    });
  }

  public getRegisteredTagReportData(): Array<RegistrationReport> {
    const reportData: Array<RegistrationReport> = this.filteredRegisteredTags.map(
      (tag) => {
        // set default values
        const data: RegistrationReport = {
          tagId: tag.code,
          firstName: '',
          lastName: '',
          phoneNumber: '',
          website: '',
          address: '',
          city: '',
          state: '',
          zipCode: '',
          createdBy: tag.createdBy?.email || '',
          createdDate: Vue.filter('localDateOnly')(tag.dateCreatedUtc),
          createdTime: Vue.filter('localTimeOnly')(tag.dateCreatedUtc),
          modifiedBy: tag.modifiedBy?.email || '',
          modifiedDate: Vue.filter('localDateOnly')(tag.dateModifiedUtc),
          modifiedTime: Vue.filter('localTimeOnly')(tag.dateModifiedUtc)
        };

        // get customer data
        if (tag.customer) {
          data.firstName = tag.customer.firstName || '';
          data.lastName = tag.customer.lastName || '';
          data.phoneNumber = tag.customer.phoneNumber || '';
          data.address = tag.customer.address1 || '';
          data.city = tag.customer.city || '';
          data.state = tag.customer.state || '';
          data.zipCode = tag.customer.zipCode || '';
          data.website = tag.customer.website || '';
        }

        return data;
      }
    );

    return reportData;
  }

  public getReportFileName() {
    const range = `${this.$moment(this.tableFilter.startDate).format(
      'M-D-YYYY'
    )}_${this.$moment(this.tableFilter.endDate).format('M-D-YYYY')}`;
    const search = this.tableFilter.search
      ? `_${snakeCase(this.tableFilter.search)}`
      : '';

    if (this.roles.includes(this.role.Admin)) {
      const index = this.accountOptions.findIndex(
        (option) => option.value === this.selectedVeterinarianOfficeId
      );
      const officeName = this.accountOptions[index].text;

      return `${snakeCase(officeName)}_${range}${search}.csv`;
    }

    return `registration_export_${range}${search}.csv`;
  }

  public onEditTagClick(registeredTag: RegisteredTag) {
    this.selectedRegisteredTag = { ...registeredTag };
    this.$bvModal.show('modal-manage-tag');
  }

  public async onCompletionHandler(newTagCode: string): Promise<void> {
    console.log('completed', newTagCode);

    if (!registeredTagModule.hasErrorMessages) {
      await this.getRegesteredTagListByOfficeId(
        this.selectedVeterinarianOfficeId
      );
    }

    this.$bvModal.hide('modal-manage-tag');
  }
}
